



































import { Component, Mixins } from 'vue-property-decorator'

import { Meta } from '@/helpers/decorators'
import Box from '@/components/common/Box.vue'
import InfoBox from '@/components/common/InfoBox.vue'
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

@Component({
  components: {
    Box,
    InfoBox
  }
})
export default class Login extends Mixins(Form, Errors) {
  email: string = null
  formLoading: boolean = false
  displayErrors: any
  $api: any
  $refs: {
    lostpassword: HTMLFormElement
  }

  async load() {
    // const res = await this.$validator.validateAll()
    try {
      this.formLoading = true
      await this.$api.user.lostPassword(this.email)
      this.$toast.open({
        message: this.$t('login.lost_password.success.title') as string,
        duration: 5000,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.formLoading = false
    }

  }
}
